module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="rotate-panel">\n    <div class="effect-name">Rotate</div>\n    ';
 if(triggerType === "hover") { ;
__p += '\n    <div class="rotate-region zmags-input-control small">\n        <label data-unit="&deg;">Rotation Angle: <input type="number" step="any" class="rotation"></label>\n    </div>\n    ';
 } ;
__p += '\n    ';
 if(triggerType === "attention") { ;
__p += '\n    <div class="radio">\n        <label>\n            <input type="radio" class="rotation-angle" name="attentionMode" value="angle">\n            Rotation Angle:\n            <div class="rotate-region zmags-input-control small">\n                <label data-unit="&deg;"><input type="number" step="any" class="rotation"></label>\n            </div>\n        </label>\n    </div>\n    <div class="radio">\n        <label>\n            <input type="radio" class="rotation-direction" name="attentionMode" value="infinite">\n            Infinite Rotation:\n            <select class="rotation-direction-selection form-control">\n                <option value="cw">Right (CW)</option>\n                <option value="ccw">Left (CCW)</option>\n            </select>\n        </label>\n    </div>\n    ';
 } ;
__p += '\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/action/properties/RotateEffectPropertiesView.tpl
// module id = 1748
// module chunks = 0